import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('logo');

    return {
        AMERICAN_AUTONOMY: t('americanAutonomy')
    };
};

export default useTranslation;
